/**
 *
 * Asynchronously loads the component for MetaAuth
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const MetaAuth = lazyLoad(
    () => import('./index'),
    module => module.default,
);
